import React from 'react';
import { Box, Grid, styled } from '@mui/material';
import { useFocusTheme } from '@/components/Focus/configs/useFocusTheme.hook';
import { FocusTheme } from '@/components/Focus/configs/theme';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { StatusColor } from '@/components/_common/Table/Calendar/utils';
import PlatformsList from '@/components/_common/Table/Calendar/CalendarSharedComponents/PlatformsList';

export interface Props {
  platforms: Set<string>;
  statusColor: StatusColor;
  primaryText: React.ReactNode;
  secondaryText: React.ReactNode;
}

const Element: React.FC<Props> = ({ statusColor, primaryText, secondaryText, platforms }) => {
  const theme = useFocusTheme();
  return (
    <Wrapper container gap={2}>
      <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
        <StatusIcon color={statusColor} />
      </Grid>
      <Grid item xs sx={{ overflow: 'hidden' }}>
        <OneLineBox>{primaryText}</OneLineBox>
        <OneLineBox sx={{ color: theme.customOverrides.Calendar.textSecondary, fontSize: '0.857rem' }}>{secondaryText}</OneLineBox>
      </Grid>
      <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
        <PlatformsList platforms={[...platforms]} />
      </Grid>
    </Wrapper>
  );
};

export default Element;

const Wrapper = styled(Grid)`
  ${({ theme }) => `
    flex-wrap: nowrap;
    margin-bottom: ${theme.spacing(0.125)};
    padding: ${theme.spacing(1, 2)};
    border-radius: ${theme.shape.borderRadius}px;
    background-color: ${(theme as FocusTheme).customOverrides.Calendar.backgroundAlt};
  `}
`;

const OneLineBox = styled(Box)`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StatusIcon: React.FC<{ color: StatusColor }> = ({ color }) => {
  return (
    <Box
      sx={{
        width: 20,
        height: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: `${color}.main`,
        borderWidth: `2px`,
        borderStyle: 'solid',
        borderColor: `${color}.main`,
        borderRadius: '50%'
      }}
    >
      {color === 'success' && <PolarisIcon icon="complete" width={12} height={12} />}
    </Box>
  );
};
